import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { likePost, unlikePost } from "../../redux/actions/postActions";
import formatCount from "../../utils/formatCount";
import { IonButton, IonIcon } from "@ionic/react";
import { heart, heartOutline } from "ionicons/icons";
function LikeBtn({ id, likes }) {
  const { data } = useSelector((state) => state.currentProfile);
  const dispatch = useDispatch();
  const [liked, setLiked] = useState(false);
  const [likedCount, setLikedCount] = useState(likes.length);
  useEffect(() => {
    // Sync local state with props on load or update
    const isLiked = likes.some((like) => like._id === data._id);
    setLiked(isLiked);
    setLikedCount(likes.length);
  }, [likes, data._id]);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Optimistic update
    setLiked((prev) => !prev);

    if (liked) {
      dispatch(unlikePost(id));
      setLikedCount((prev) => prev - 1);
    } else {
      dispatch(likePost(id));
      setLikedCount((prev) => prev + 1);
    }
  };

  return (
    // <button
    //   onClick={handleClick}
    //   className={`display-flex align-items-c post-btns__btn ${liked ? "post-btns__like--active" : "post-btns__like"
    //     }`}
    // >
    //   <IonIcon

    //     className={liked ? 'heart-red' : ''}
    //     icon={liked ? heart : heartOutline} />
    //   <small>{formatCount(likedCount)}</small>
    // </button>
    <IonButton
      fill="clear"
      size="small"
      shape="round"
      onClick={handleClick}
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      className={`sidebar-icon display-flex align-items-c post-btns__btn post-btns__reply no-padding-btn ion-no-padding ${
        liked ? "post-btns__like--active" : "post-btns__like"
      }`}
    >
      <IonIcon
        slot="start"
        icon={liked ? heart : heartOutline}
        className={liked ? "heart-red" : ""}
      />
      <p className={liked ? "heart-red" : ""}>{formatCount(likedCount)}</p>
    </IonButton>
  );
}

export default LikeBtn;

